import { declareAction } from '@reatom/core';

import { NAME } from './contstants';

export const openRequestPanelAction = declareAction(`${NAME}OpenAction`);

export const closeRequestPanelAction = declareAction(`${NAME}CloseAction`);
